import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from "axios";
import isEmpty from "lodash/isEmpty";

// Components
import Select from 'react-select'
import Loader from '../../utils/Loader';

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";
import { loadTopTiers } from '../../../store/actions/topTier';

class AdminCustomerEmails extends Component {
    constructor(props){
        super(props)
        this.state = {
            errors: {},
            isLoading: false,
            isLoadingTT: false,
            fileCreated: false,
            fileCreatedTT: false,
            fileName: "",
            fileNameTT: "",
            topTierIndex: null,
            topTierSelected: {},
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Customer Download')

        this.style = {
            display: 'flex',
            alignItems: 'center',
            background: '#a92323'
        }

        this.messageStyle = {
            fontWeight: 'bold',
            color: '#a92323',
            fontSize: '1.1em',
            paddingTop: '0.75em'
        }
    }

    componentDidMount(){
        this.props.loadTopTiers();
    }

    handleSelectBoxChange = (id) => {
        this.setState({   
            topTierIndex: id,
            topTierSelected: this.props.topTiers[id]
        }, 
        () => { 
            this.setState({
                fileNameTT: false,
                fileCreatedTT: false
            }, () => this.props.loadTopTiers())
        });
    }

    generateFile = () => {

        const { user } = this.props;

        this.setState(
            {isLoading: true},
            () => {
                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
                return axios
                    .get(REACT_APP_API_URL + "customer-file", { headers: AUTH_HEADER })
                    .then(response => {
                        console.log(response)
                        if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                            this.props.userLogout("admin");
                        } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                            this.setState({ isLoading: false, error: response.data.message });
                        } else {
                            this.setState({
                                isLoading: false,
                                fileCreated: true,
                                fileName: response.data.file
                            });
                        }
                    })
                    .catch(err => {
                        if (err.response) {
                            this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                        } else {
                            this.setState({ isLoading: false, error: err.message });
                        }
                    });
            }
        );
    }

    generateTopTierFile = () => {
        const { user } = this.props;
        console.log(this.state.topTierSelected);
        this.setState(
            {isLoadingTT: true},
            () => {
                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
                return axios
                    .get(REACT_APP_API_URL + "customer-file/" + this.state.topTierSelected.id, { headers: AUTH_HEADER })
                    .then(response => {
                        console.log(response)
                        if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                            this.props.userLogout("admin");
                        } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                            this.setState({ isLoading: false, error: response.data.message });
                        } else {
                            this.setState({
                                isLoadingTT: false,
                                fileCreatedTT: true,
                                fileNameTT: response.data.file
                            });
                        }
                    })
                    .catch(err => {
                        if (err.response) {
                            this.setState({ isLoadingTT: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                        } else {
                            this.setState({ isLoadingTT: false, error: err.message });
                        }
                    });
            }
        );
    }

    render() {
        const {isLoading, isLoadingTT, fileCreated, fileCreatedTT, fileName, fileNameTT, topTierIndex} = this.state;
        const {topTiers, topTiersLoading} = this.props;

        // Select Box Values
        const topTierOptions = [];
        let i = 0;
        !isEmpty(topTiers) && topTiers.forEach(element => {
            topTierOptions.push({value: i++, label: element.name});
        })

        console.log(fileNameTT);

        return (
            <div>
                <h1>Download Customer Emails</h1>
                {!fileCreated 
                    ? <button className="btn" onClick={() => this.generateFile()}>{isLoading && !fileCreated ? 'Generating...' : 'Generate CSV File'}</button>
                    : <a href={fileName}><button className="btn" style={this.style}><div className="icon-checkmark" style={{marginRight: '0.75em'}}></div> Click To Download</button></a>
                }
                <hr style={{margin: '3em 0'}}/>
                <h1>Download Top Tier Customers</h1>
                {topTiersLoading ?
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                <React.Fragment>
                <div className="tt-prod-select">
                    <div className="tt-prod-select-label">Select Top Tier:</div>
                    <Select className="select-box" 
                        name={`top_tier_id`} 
                        value={topTierIndex} 
                        onChange={selection => this.handleSelectBoxChange(selection.value)} 
                        clearable={false} 
                        valueKey="value"
                        labelKey="label" 
                        options={topTierOptions} 
                    />
                </div>
                {topTierIndex != null &&
                    <React.Fragment>
                        {fileNameTT === null && <div style={this.messageStyle}>File not created. No customers exist in this top tier</div>}
                        {!fileCreatedTT || fileNameTT === null
                        ? <button className="btn" onClick={() => this.generateTopTierFile()}>{isLoadingTT && !fileCreatedTT ? 'Generating...' : 'Generate CSV File'}</button>
                        : <a href={fileNameTT}><button className="btn" style={this.style}><div className="icon-checkmark" style={{marginRight: '0.75em'}}></div> Click To Download</button></a>
                        }
                    </React.Fragment>
                }
                </React.Fragment>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        topTiers: state.topTier.topTiers,
        topTiersLoading: state.topTier.topTiersLoading
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, loadTopTiers, userTokenUpdate, userLogout })(AdminCustomerEmails)



// WEBPACK FOOTER //
// ./src/components/admin/users/AdminCustomerEmails.js